












































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import PermissionService from '@/utils/permission-service';
import ApplicationModeService from '@/utils/application-mode-service';

@Component
export default class PaycheckMode extends Vue {
  private handleOpen = ApplicationModeService.sidebarExpanded;
  private isDebugMode: boolean = process.env.VUE_APP_DEBUG_PAGES === 'true';
  public PermissionService = PermissionService;

  @Watch('handleOpen')
  private onExpandChange(value: boolean): void {
    ApplicationModeService.toggleSidebarExpanded(value);
  }
}
